<template>
  <g>
    <path
      fill="#2196F3"
      d="M48.823 97c26.786 0 48.5-21.714 48.5-48.5S75.609 0 48.823 0 .323 21.714.323 48.5 22.037 97 48.823 97z"
    />
    <path
      fill="#fff"
      d="M70.599 28.903l-21.826-6.547c-.204-.061-.422-.061-.626 0l-21.825 6.547c-.462.138-.779.563-.779 1.046v24.006c0 9.648 14.714 18.232 22.593 20.685.213.067.442.067.655 0 7.87-2.453 22.585-11.037 22.585-20.685V29.949c0-.482-.316-.907-.778-1.046z"
    />
    <path
      fill="#2196F3"
      d="M34.258 48.987c-.695 0-1.258-.563-1.258-1.258v-2.47c0-.696.563-1.259 1.258-1.259.696 0 1.259.563 1.259 1.258v2.47c0 .696-.563 1.26-1.259 1.26zM63.741 48.987c-.695 0-1.258-.563-1.258-1.258v-2.47c0-.696.563-1.259 1.258-1.259.695 0 1.259.563 1.259 1.258v2.47c0 .696-.564 1.26-1.259 1.26zM49.076 50.883c-1.868 0-3.643-.809-4.872-2.219-.457-.524-.402-1.319.122-1.775.524-.457 1.319-.402 1.775.122.751.861 1.835 1.355 2.975 1.355 1.14 0 2.224-.494 2.974-1.355.457-.524 1.252-.579 1.776-.122.524.456.578 1.251.122 1.775-1.23 1.41-3.005 2.22-4.872 2.22z"
    />
  </g>
</template>

<script>
export default {
  name: 'circleNotifications'
}
</script>
